export default "__VITE_ASSET__CgH4_hiT__"